<template>
  <div class="project-practice">
    <template v-if="!noTeam">
      <div
        class="catalogue-item clearfix"
        v-for="item in catalogues"
        :key="item.id"
      >
        <div class="title">{{ item.name }}</div>
        <div class="btns">
          <el-button
            v-if="status[item.openStr]"
            class="btn"
            size="mini"
            type="primary"
            plain
            @click="handleStart(item.label)"
            >开始实操</el-button
          >
        </div>
      </div>
    </template>
    <!-- 空状态 -->
    <empty-status
      v-else
      desc="您还没加入团队，请先加入团队或创建团队"
      buttonText="创建 / 加入团队"
      haveButton
      @btnClick="
        $router.push({ path: '/classCourse/teams', query: { ...$route.query } })
      "
    />
  </div>
</template>

<script>
import { myTeam } from "@/api/team";
import { status } from "@/api/projectPractice/common";
import emptyStatus from "@/components/emptyStatus/index";

export default {
  components: {
    emptyStatus,
  },
  data() {
    return {
      noTeam: false,
      catalogues: [
        {
          id: 1,
          name: "项目一 团队组建",
          label: "buildTeam",
          openStr: "zjOpen",
        },
        {
          id: 2,
          name: "项目二 账号定位",
          label: "accountLocation",
          openStr: "dwOpen",
        },
        {
          id: 3,
          name: "项目三 账号搭建",
          label: "accountEstablish",
          openStr: "djOpen",
        },
        {
          id: 4,
          name: "项目四 文案创作",
          label: "copywriting",
          openStr: "waOpen",
        },
        {
          id: 5,
          name: "项目五 脚本创作",
          label: "scenario",
          openStr: "jbOpen",
        },
        {
          id: 6,
          name: "项目六 视频拍摄",
          label: "videoShooting",
          openStr: "psOpen",
        },
        {
          id: 7,
          name: "项目七 视频剪辑",
          label: "videoClip",
          openStr: "jjOpen",
        },
        {
          id: 8,
          name: "项目八 账号运营",
          label: "accountOperation",
          openStr: "yyOpen",
        },
        {
          id: 9,
          name: "项目九 成果路演",
          label: "roadshow",
          openStr: "lyOpen",
        },
        {
          id: 10,
          name: "项目十 数据分析",
          label: "analysis",
          openStr: "fxOpen",
        },
      ],
      status: {},
    };
  },
  async created() {
    let res = await myTeam({ classId: this.$route.query.id });
    this.noTeam = res.data ? false : true;
    if (!this.noTeam) this.getStatus();
  },
  methods: {
    // 项目状态
    getStatus() {
      this.$loading.show();
      status({ classId: this.$route.query.id }).then((res) => {
        this.$loading.hide();
        if (res.code == 0) {
          this.status = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    handleStart(label) {
      this.$router.push({
        path: `/classCourse/projectPractice/${label}`,
        query: this.$route.query,
      });
    },
  },
};
</script>

<style lang="less" scoped>
.project-practice {
  // background-color: #fff;
  .catalogue-item {
    margin-bottom: 20px;
    line-height: 38px;
    background-color: #f0f7ff;
    box-shadow: 0 6px 12px 0 rgba(0, 0, 0, 0.1);
    .title {
      float: left;
      padding: 0 20px;
      font-size: 17px;
      color: #303133;
      font-weight: bold;
    }
    .btns {
      float: right;
      margin-right: 10px;
    }
  }
}
</style>